import React from 'react'

import { PageGuardKinerjaHarianV2 } from 'app/KinerjaHarian/components/PageGuardKinerjaHarianV2'
import { useKinerjaHarianPSActive } from 'app/KinerjaHarian/hooks/useKinerjaHarianPSActive'

export function PageGuardKinerjaHarianPS({
  children,
}: {
  children: React.ReactNode
}) {
  const { isActive, isPerencanaanReady, isLoading } = useKinerjaHarianPSActive()

  return (
    <PageGuardKinerjaHarianV2
      isActive={isActive}
      isPerencanaanReady={isPerencanaanReady}
      isLoading={isLoading}
    >
      {children}
    </PageGuardKinerjaHarianV2>
  )
}
